// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textarea-custom.theme--dark.v-input--is-disabled .v-input__slot,.textarea-custom.theme--light.v-input--is-disabled .v-input__slot{background:#f5f5f5!important}.optional-text{font-size:.8rem!important;font-weight:400!important}.warning-hint .v-messages__message{color:red!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
